import React from "react";

interface Layer {
  /** Image URL */
  src: string;
  /** 0 = far / slow, 1 = near / fast */
  depth: number;
}

interface Props {
  /** Array of image layers ordered back-to-front */
  layers: Layer[];
  /** Full drift cycle duration seconds, default 12 */
  dur?: number;
}

/**
 * Parallax — 2–3 image layers drifting at different speeds to create depth.
 * Layers with higher `depth` values move faster (nearer objects).
 */
const Parallax: React.FC<Props> = ({ layers, dur = 12 }) => (
  <div style={{ position: "absolute", inset: 0, overflow: "hidden" }}>
    {layers.map((l, i) => {
      // Bake the amplitude value directly into a unique keyframe per layer —
      // CSS custom props set via inline style can't be read inside @keyframes.
      const amp = -6 - l.depth * 14;
      const kf  = `oot-parallax-${i}`;
      return (
        <React.Fragment key={i}>
          <style>{`
            @keyframes ${kf} {
              0%   { transform: translateX(0); }
              50%  { transform: translateX(${amp}px); }
              100% { transform: translateX(0); }
            }
          `}</style>
          <img
            src={l.src}
            alt=""
            style={{
              position: "absolute",
              inset: 0,
              width: "110%",
              height: "100%",
              objectFit: "cover",
              animation: `${kf} ${dur / (0.5 + l.depth)}s ease-in-out infinite`,
              zIndex: i,
            }}
          />
        </React.Fragment>
      );
    })}
  </div>
);

export default Parallax;
